// @ts-nocheck

import { createAction, createSlice } from '@reduxjs/toolkit';

import { repairOrderApi } from '../lib/api';
import type { RepairOrder } from '../lib/types';

export const CLEAR_REPAIR_ORDER = 'vehicles/repair-order/clear';
export const SET_REPAIR_ORDER = 'vehicles/repair-order/set';

const initialState: RepairOrder | null = null;

const clearRepairOrderAction = createAction(CLEAR_REPAIR_ORDER);
const setRepairOrderAction = createAction<RepairOrder>(SET_REPAIR_ORDER);

const repairOrderSlice = createSlice({
  name: 'repairOrder',
  initialState: initialState as RepairOrder | null,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setRepairOrderAction, (state, { payload }) => payload)
      .addCase(clearRepairOrderAction, () => initialState);
  },
});

export const repairOrderActions = {
  clear: clearRepairOrderAction,
  set: setRepairOrderAction,
};

export const clear = () => (dispatch) => dispatch(repairOrderActions.clear());

export const addRepairOrder = (repairOrder) => async (dispatch) => {
  const addedRepairOrder = await repairOrderApi.addRepairOrder(repairOrder);
  dispatch(repairOrderActions.set(addedRepairOrder));
  return addedRepairOrder;
};

export const updateRepairOrder = (repairOrder) => async (dispatch) => {
  const updatedRepairOrder = await repairOrderApi.updateRepairOrder(
    repairOrder
  );
  dispatch(repairOrderActions.set(updatedRepairOrder));
  return updatedRepairOrder;
};

export const deleteRepairOrder = (id) => async () =>
  repairOrderApi.deleteRepairOrder(id);

export const fetchRepairOrder = (id) => async (dispatch) => {
  const repairOrder = await repairOrderApi.fetchRepairOrder(id);
  dispatch(repairOrderActions.set(repairOrder));
  return repairOrder;
};

export default repairOrderSlice.reducer;
